export default __webpack_public_path__ + "061da4a33342c27f2e6df4c1d316b5ed.svg";